import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import { giftCardDataInquiry } from 'actions/EntityActions';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class POSGiftCardInquiry extends Component {
    constructor(props, context) {
        super(props, context);
    }

    confirmCardInquiry = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            Pan: p.pan,
            Expdate: p.expdate,
            CvdValue: p.cvdValue,
            TerminalId: p.terminalId,
            ProcessMethod: p.proceddMethod === true ? 1 : 0
        };
        //console.log(model);
        this.props.giftCardDataInquiry(model);
    }

    render() {
        const { t } = this.props; 
        let p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose style="pink" text={t('pos.giftCard.dataInquiry.label')} handleClose={() => this.props.onCancel()} />}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.confirmCardInquiry()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <ToggleInput className="giftCard_process_method" name={`${p.name}processMethod`} label={t('pos.giftCard.processMethod.label')} />
                    </div>
                    {
                        this.props.proceddMethod ?
                        (
                            <div>
                                <h4>{t('pos.giftCard.inquiry.fillUpInfo')}</h4>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}pan`}
                                            fullWidth={true}
                                            label={t('common.cardNum')}
                                            floatingLabelText={t('common.cardNum')}
                                            hintText={t('common.cardNum')} />
                                    </div>
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}expdate`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.expdateWithFormat.label')}
                                            floatingLabelText={t('pos.giftCard.expdateWithFormat.label')}
                                            hintText={t('pos.giftCard.expdateWithFormat.hintText')} />
                                    </div>
                                    <div className="col-lg-12">
                                        <TextInput name={`${p.name}cvdValue`}
                                            fullWidth={true}
                                            label={t('pos.giftCard.cvdValue.label')}
                                            floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                            hintText={t('pos.giftCard.cvdValue.hintText')} />
                                    </div>
                                </div>
                            </div>
                        )
                        :
                        (
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h5>{t('pos.giftCard.readyToSwipeCard.text')}</h5>
                                <TextInput name={`${p.name}cvdValue`}
                                    fullWidth={true}
                                    label={t('pos.giftCard.cvdValue.label')}
                                    floatingLabelText={t('pos.giftCard.cvdValue.label')}
                                    hintText={t('pos.giftCard.cvdValue.hintText')} />
                            </div>
                        )


                    }
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        pan: state.form[`POSGiftCardInquirypan`] || '',
        expdate: state.form[`POSGiftCardInquiryexpdate`] || '',
        cvdValue: state.form[`POSGiftCardInquirycvdValue`] || '',
        proceddMethod: state.form[`POSGiftCardInquiryprocessMethod`],
        terminalId: state.entity.cashFlow ? state.entity.cashFlow.terminalId : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        giftCardDataInquiry: (model) => dispatch(giftCardDataInquiry(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCardInquiry));